import React from "react";
import bannerImg from "../images/banner-img.png";
import Breadcrumbs from "../../../../components/breadcrumbs/Breadcrumbs";

const Banner = () => {
  const isMdDevice = window.innerWidth >= 768;
  return (
    <section
      style={{
        background: `linear-gradient(${
          isMdDevice ? 90 : 180
        }deg, #0B3D8C 0.11%, #107CC4 54.49%, rgba(6, 175, 169, 0.745055) 83.43%)`,
      }}
    >
      <div className="container max-w-screen-2xl text-white py-6">
        <div className="flex flex-col md:flex-row gap-8">
          <div className="relative w-full md:w-1/2 flex flex-col justify-center pt-12 md:pt-0">
            <div className="mb-auto">
              <Breadcrumbs
                links={[
                  { name: "Home", path: "/" },
                  {
                    name: "List of scholarships in India",
                    path: "/scholarship-intermediate",
                  },
                ]}
              />
            </div>
            <h1 className="text-4xl mt-12 md:mt-0 font-bold">
              List of Scholarships in India
            </h1>
            <p className="text-lg md:text-2xl mt-4 mb-auto font-light">
              India offers a diverse range of scholarships to support students
              at all educational levels - from{" "}
              <span className="font-bold">
                School through Undergraduate, Graduate, and Doctoral Studies.
              </span>{" "}
              These scholarships, provided by both{" "}
              <span className="font-bold">
                Government and Private organizations,
              </span>{" "}
              offer financial aid based on{" "}
              <span className="font-bold">Merit or Need</span>, making higher
              education more accessible.
            </p>
          </div>
          <div className="w-full md:w-1/2 flex items-center justify-center">
            <img
              src={bannerImg}
              className="w-full md:w-2/3 aspect-square object-cover rounded-full"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
